import axios, { config } from '..';
import {
  FETCH_BANKS_SUCCESS,
  FETCH_BANKS_FAILED,
  CLEAR_PAYMENTS,
  CLEAR_UPDATE_PROVIDER,
} from '../../actionTypes';

export default () => async (dispatch) => {
  try {
    dispatch({ type: CLEAR_UPDATE_PROVIDER });
    dispatch({ type: CLEAR_PAYMENTS });

    const response = await axios.get('/payouts/banks', config);

    const {
      data: {
        message,
        data: { data },
      },
    } = response;
    dispatch({
      type: FETCH_BANKS_SUCCESS,
      message,
      results: data,
    });
  } catch (err) {
    let error = {};
    if (err.response) {
      const {
        data: { status, message },
      } = err.response;
      error = { status, message };
    } else {
      error = {
        status: 500,
        message: err.message,
      };
    }
    dispatch({ type: FETCH_BANKS_FAILED, error });
  }
};
